import zIndex from "@mui/material/styles/zIndex";
import { fontSize } from "@mui/system";
import { filter } from "lodash";

export default {
  root: { width: "100%", paddingLeft: 8, paddingRight: 8, paddingTop: 8, paddingBottom: 8 },
  container: { maxWidth: 1440, marginLeft: "auto", marginRight: "auto" },
  paper: {
    padding: 24,
    "& > $headerRow, & > $formRow, & > $resultsWrap" : { height: "auto !important" }
  },

  headerRow: { display: "flex", alignItems: "center", marginBottom: 16 },
  headerIcon: { marginRight: 8 },

  formRow: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
    columnGap: 8,
    alignItems: "center",
    marginBottom: 16
  },
  vinField: { width: "100%", "& .MuiInputBase-root": { height: 40 } },
  searchButton: { height: 40, paddingLeft: 16, paddingRight: 16 },

  loading: { marginTop: 24, display: "flex", justifyContent: "center" },
  errorText: { marginTop: 8 },

  resultsWrap: { marginTop: 16 },
  resultsTitle: { fontWeight: 700, marginBottom: 8 },
  divider: { marginBottom: 12 },
  row: { display: "grid", gridTemplateColumns: "40% 60%", justifyContent: "space-between", columnGap: 16,  alignItems: "start", marginBottom: 12 },
  rowLabel: { fontWeight: 700, color: "text.secondary" },
  rowValue: { width: "58%", wordBreak: "break-all", overflowWrap: "anywhere", whiteSpace: "normal"  },


  mapContainer: { 
    position: "relative",
    marginTop: 16,
    height:"360px !important",
    zIndex: 1,
    "& > div": { height: "100% !important" },
    "& .gm-style": { height: "100% !important" },
    pointerEvents:"auto"
  },

  carIcon:{
    fontSize: 32,
    color: "#f7f5f5ff",
    filter: "drop-shadow(0 0 2px rgba(0,0,0,0.5))"
  },

  mapToggle: {
    position: "absolute",
    right: 8,
    top: 8,
    zIndex: 3,
    pointerEvents: "auto"
  },

  CircleOptions: {
    strokeColor: "#40c93bff",
    strokeOpacity: 0.5,
    strokeWeight: 2,
    fillColor: "#40c93bff",
    fillOpacity: 0.25,
    clickable: false
  },

  mapLink: { marginTop: 8 }
};
